import { Pipe, PipeTransform } from '@angular/core';
import { InvitationType } from '../models/InvitationType.enum';

@Pipe({
  name: 'invitationTypeIcon',
})
export class InvitationTypeIconPipe implements PipeTransform {
  transform(value: unknown, arg?: 'key' | 'value' | unknown): unknown {
      let enumValue;
      if (arg === "key") {
        enumValue = InvitationType.retrieveValueByKey(value as string);
      } else {
        enumValue = value as string;
      }
      return InvitationType.retrieveIconByValue(enumValue);
    }
}
